module.exports = __webpack_public_path__ + "../resources/images/DragInMail-71836da2badd6961521b98bdddf6f87c.gif";